import React, { Component } from "react";
import { createPortal } from "react-dom";

export default class Frame extends Component {
  constructor(props) {
    super(props);

    this.setContentRef = (node) =>
      (this.contentRef =
        (node &&
          node !== null &&
          node.contentWindow &&
          node.contentWindow.document &&
          node.contentWindow.document.body) ||
        null);
  }

  componentDidMount() {
    setTimeout(() => {
      this.forceUpdate();
    }, 3000);
  }

  render() {
    const { children, ...props } = this.props; // eslint-disable-line
    return (
      <iframe {...props} ref={this.setContentRef} title="Preview">
        {this.contentRef &&
          createPortal(React.Children.only(children), this.contentRef)}
      </iframe>
    );
  }
}
